// @flow

import * as React from 'react';
import { css } from '@emotion/core';
import colors from "../../Styles/colors";
import {h1standard} from "../../Styles/text";

let rowTitle = css`
  margin-top: 0;
  margin-right: 15px;
  margin-left: 15px;
  color: ${colors.coreColor2};
  
  @media(min-width: 641px) {
    ${h1standard};
    font-weight: 800;
    margin: 64px 0 16px 0;
    color: #fff;
    text-align: center;
  }
`;

type Props = {|
  title: string
|};

export default React.memo<Props>(function RowTitle({ title }) {
  return <h3 css={rowTitle} className="headline">{title}</h3>;
});